module.exports = __webpack_public_path__ + "img/gift4-01-c10-y2.2257a534.png";